import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import LoadedMileageFrame from './LoadedMileageFrame';
import LinearMileageFrame from './LinearMileageFrame';
import { showHospitalToHospitalWarning } from '../../../flags/service.flag';
import moment from 'moment';

const METERS_IN_MILE = 0.000621371;
function DistanceContainer({ requireLinearDistance, ...props }) {
  return (
    <>
      {!requireLinearDistance && <LoadedMileageFrame {...props} />}
      {requireLinearDistance && <LinearMileageFrame {...props} />}
    </>
  );
}

const departureTime = dropOffSegment => {
  if (dropOffSegment && dropOffSegment.start_at) {
    const startAt = moment(dropOffSegment.start_at);
    if (startAt.isBefore(moment())) {
      return null;
    }
    return dropOffSegment.start_at;
  }
  return null;
};

const calculateSegmentLoadedMileage = segment => {
  if (!segment || !segment.meters) {
    return 0;
  }

  return Math.round(segment.meters * METERS_IN_MILE * 10) / 10;
};

function mapStateToProps(state) {
  const fromWaypoint = state.map.fromWaypoint;
  const toWaypoint = state.map.toWaypoint;
  const isRequestCompleted = state.requests.request.isCompleted;
  const toDropOffSegment = state.schedule.segments?.find(s => s.state === 'to_drop_off');
  return {
    fromWaypoint,
    toWaypoint,
    grow: !!showHospitalToHospitalWarning(state),
    requireLinearDistance: get(state.agency.requesterAgencyGroup, 'requireLinearDistance', false),
    departureTimeForMileageCalculation: departureTime(toDropOffSegment),
    isRequestCompleted,
    distance: calculateSegmentLoadedMileage(toDropOffSegment),
  };
}

DistanceContainer.propTypes = {
  requireLinearDistance: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, {})(DistanceContainer);
